<script setup lang="ts">
const items = [
  {
    title: 'Saldo Digital Prabayar',
    description: 'Untuk pembayaran paket & ROMS di dashboard KiriminAja.',
    icon: 'ic:outline-payments'
  },
  {
    title: 'Limit Fleksibel',
    description: 'Bisa diisi mulai dari Rp100.000 hingga Rp2.000.000.',
    icon: 'material-symbols:trending-up'
  },
  {
    title: 'Multi-Level Akses',
    description: 'Owner, finance, dan staff operasional dalam satu sistem.',
    icon: 'material-symbols:spoke-outline'
  },
  {
    title: 'Transaksi Otomatis Terintegrasi',
    description: 'Saldo langsung terpotong dan tercatat real-time',
    icon: 'material-symbols:credit-score-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Satu Saldo untuk Semua Pembayaran Pengiriman"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-4">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
